import script from "./AccountInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./AccountInfoDialog.vue?vue&type=style&index=0&id=0c95f037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c95f037"]])

export default __exports__